var funcIter = 0;
function leadSource() {
    setTimeout(() => {
        funcIter++;
        //console.log(funcIter)
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const attr = document.querySelector("[id$=Leadsource] input");
    
        if(attr) {
            //console.log(urlParams.get("Leadsource"));
    
            attr.focus();
            attr.setAttribute("value", urlParams.get("Leadsource"));
            setTimeout(() => {
                attr.blur();
            }, 500)
        } else if (!attr && funcIter < 10) {
            leadSource();
        } else {
            return;
        }  
    },300)
};

export { leadSource }